import cogoToast from 'cogo-toast';
import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import { Constant } from '../../../../../Containers/Helpers/constant.js';
import apiCall from '../../../apiCall.js';

import { UPLOAD_PRICE_FILE, UPLOAD_PRICE_FILE_SUCCESS, UPLOAD_PRICE_FILE_ERROR } from './../../../actionType.js';

function* uploadPriceType({ payload }) {
  try {
    console.log('Payload', payload);
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/benefit-type/airport-transfer/${payload?.priceType}/upload`,
      method: 'POST',
      data: payload.data,
      isFormData: true,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success('File uploaded successfully');
      yield put({
        type: UPLOAD_PRICE_FILE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({ type: UPLOAD_PRICE_FILE_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: UPLOAD_PRICE_FILE_ERROR, payload: error });
  }
}

export function* watchuploadPriceType() {
  yield takeEvery(UPLOAD_PRICE_FILE, uploadPriceType);
}

function* uploadPriceTypeSaga() {
  yield all([fork(watchuploadPriceType)]);
}

export default uploadPriceTypeSaga;
